import { render, staticRenderFns } from "./IconLink.vue?vue&type=template&id=20c5c24a"
import script from "./IconLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconLink.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports